import React, { useEffect, useState, useRef } from "react";
import Tables from "./Tables";
import Tab from "./Tab";
import ArrowLeft from "../../common/images-new/arrow-left-blue-icon.svg"
import ArrowRight from "../../common/images-new/arrow-right-blue-icon.svg"
import { BgWhite, TextGray, ActiveIconColor } from "../Theme";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const ValueComp = ({ data, isValue }) => {
    const ref = useRef()

    const scroll = (scrollOffset) => {
        ref.current.scrollLeft += scrollOffset;
    }

    const [currentPage, setCurrentPage] = useState(0)

    const [tabNames, setTabNames] = useState([])
    const [tabData, setTabData] = useState([])

    useEffect(() => {
        if (data && (data.length > 0)) {
            setTabNames(data.map(valGroup => valGroup.name))
            setTabData(data[currentPage].children)
        }
    }, [data, currentPage])

    return (
        <BgWhite className="flex flex-col bg-white items-center pt-10 pb-5">
            <p className="font-bold text-center md:text-2xl pb-5">My Values and Competencies</p>

            {
                (tabNames.length > 0) ?
                    <>
                        <Tab tabs={tabNames} page={currentPage} setPage={setCurrentPage} />

                        <div className="flex flex-row justify-center items-center md:space-x-2 px-12 xl:px-16 w-screen relative">

                            <div className="flex item-center cursor-pointer hover:opacity-80 absolute left-5 lg:left-10">
                                {/* <img src={ArrowLeft} alt="arrow left" onClick={() => scroll(-300)}></img> */}
                                <ActiveIconColor>
                                    <MdKeyboardArrowLeft className="hover:opacity-50 cursor-pointer w-8 h-8" onClick={() => scroll(-300)} />
                                </ActiveIconColor>
                            </div>

                            <div className="xl:mb-5 overflow-x-auto no-scrollbar" ref={ref}>
                                <Tables data={tabData} isValue={isValue} />
                            </div>

                            <div className="flex item-center cursor-pointer hover:opacity-80 absolute right-5 lg:right-10">
                                {/* <img src={ArrowRight} alt="arrow right" onClick={() => scroll(300)}></img> */}
                                <ActiveIconColor>
                                    <MdKeyboardArrowRight className="hover:opacity-50 cursor-pointer w-8 h-8" onClick={() => scroll(300)} />
                                </ActiveIconColor>
                            </div>
                        </div>
                    </>
                    :
                    <TextGray className="italic">Competency is not defined</TextGray>
            }
        </BgWhite>


    )
}

export default ValueComp
